import { Store } from './store';

export const selectEncryptedJourneyId = (state: Store) => state.encryptedJourneyId;

export const selectMembers = (state: Store) => state.members;

export const selectOfflineSubmitted = (state: Store) => state.offlineSubmitted;

export const selectPaymentError = (state: Store) => state.paymentError;

export const selectManualPayment = (state: Store) => state.isManualPayment;

export const selectSetJourneyId = (state: Store) => state.setJourneyId;

export const selectSetMembers = (state: Store) => state.setMembers;

export const selectPendingUnPaidFinesError = (state: Store) => state.pendingUnPaidFinesError;

export const selectSetJourneyPaymentError = (state: Store) => state.setJourneyPaymentError;

export const selectSetIsOfflineSubmitted = (state: Store) => state.setIsOfflineSubmitted;

export const selectSetManualPayment = (state: Store) => state.setManualPayment;

export const selectDocumentError = (state: Store) => state.documentError;

export const selectSetDocumentError = (state: Store) => state.setDocumentError;

export const selectSetPendingUnPaidFinesError = (state: Store) => state.setPendingUnPaidFinesError;

export const selectIsRedirectFormIcp = (state: Store) => state.isRedirectFromIcp;

export const selectSetIsRedirectFormIcp = (state: Store) => state.setIsRedirectFormIcp;
